import { useCallback } from 'react';

import { DEFAULT_TIMEZONE_ID } from 'shared/constants/dates';
import { useSchoolTimezone } from 'shared/hooks/school';
import { formatWithTimezone } from 'shared/utils/date';

export const useFormatDateWithTimezone = (callback: (date: Date) => string) => {
  const { id: timezone } = useSchoolTimezone() || { id: DEFAULT_TIMEZONE_ID };

  return useCallback(
    (date: Date) => formatWithTimezone(date, timezone, callback),
    [callback, timezone],
  );
};
